export default function useSeatPricing(businessId: MaybeRefOrGetter<string>) {
  const { currentPricePlan, billing } = storeToRefs(useBusinessStore())
  const { usageData } = useUsageData(businessId)

  const currency = computed(() => usageData.value?.currency ?? billing.value.currency ?? 'EUR')

  const isYearlyPlan = computed(() => currentPricePlan.value?.cycle === 'YEARLY')

  const seatPrice = computed(() => usageData.value?.price.seat ?? 0)

  return { usageData, currency, seatPrice, isYearlyPlan }
}
